'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var useOnScreen = function useOnScreen(ref) {
  var _useState = React.useState(false),
      _useState2 = slicedToArray['default'](_useState, 2),
      isOnScreen = _useState2[0],
      setIsOnScreen = _useState2[1];

  var observer;
  React.useEffect(function () {
    if (ref.current && typeof window !== 'undefined' && window.IntersectionObserver) {
      observer = new IntersectionObserver(function (obsv) {
        setIsOnScreen(obsv[0].isIntersecting);
      });
    } else {
      setIsOnScreen(false);
    }
  }, []);
  React.useEffect(function () {
    var _observer$observe, _observer;

    if (ref && ref.current && ((_observer$observe = (_observer = observer) === null || _observer === void 0 ? void 0 : _observer.observe) !== null && _observer$observe !== void 0 ? _observer$observe : false)) {
      observer.observe(ref.current);
      return function () {
        observer.disconnect();
      };
    }
  }, [ref]);
  return isOnScreen;
};

exports.useOnScreen = useOnScreen;